module.exports = __webpack_public_path__ + "static/media/logo.93333e5c.svg";